<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :hot-key-create-path="'/stock-take/create'"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Stocktakes" />
    </template>
    <div class="css-v2 transaction-list">
      <gc-filter-split-view
        :showLeftContainer="showFilterLeftContainer"
        :showRightContainer="showFilterRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight - 20"
            :columns="columns"
            @content-ready="addGridNoResults($event)"
            @cell-click="onMasterCellClick"
            ref="stocktake-grid"
          >
            <template #status-cell-template="{ data }">
              <gc-status-chip :status="data.data.FriendlyStatus" />
            </template>

            <template #menu-cell-template="{ data }">
              <DxDropDownButton
                :items="[
                  { menuText: 'Commit', data: data },
                  { menuText: 'Cancel', data: data },
                ]"
                keyExpr="menuText"
                displayExpr="menuText"
                :drop-down-options="{ width: 250 }"
                class="gc-dropdown-icon-button"
                icon="overflow"
                styling-mode="text"
                :show-arrow-icon="false"
                :onItemClick="onItemClick"
                :visible="
                  data.data.FriendlyStatus !== 'Completed' &&
                  data.data.FriendlyStatus !== 'Cancelled' &&
                  hasCommitCancelAccess
                "
              />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :setFilterFormHeight="filterFormHeight"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'stocktake-list'"
            :data-source-config="dataSourceConfig"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { StockTakeListService } from "../../_services/api/inventory/stock-take-list.service";

import BaseViewMixin from "../../v1/_mixins/base.view";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Stocktakes",
          message: "Get Started, Add a Stocktake",
        },
      },
      filterValue: null,
      advanceFilterModel: {
        Type: "",
        CountDate: null,
        DateCreated: null,
        CommitedDate: null,
      },
    };
  },
  components: {},
  computed: {
    dataSourceConfig() {
      return StockTakeListService.dataSourceConfig("api/StocktakeList", {
        select: [
          "Code",
          "Type",
          "CountDate",
          "CommittedDate",
          "FriendlyStatus",
          "CreatedBy",
          "DateCreated",
        ],
        // sort: [{ selector: "Code", desc: true }],
      });
    },

    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Run Number",
          dataField: "Code",
          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
        },

        {
          gcLabel: "Type",
          dataField: "Type",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(150),
        },
        {
          gcLabel: "Count Date",
          dataField: "CountDate",
          gcType: "Date",
        },
        {
          gcLabel: "Date Created",
          dataField: "DateCreated",
          gcType: "Date",
        },
        {
          gcLabel: "Date Committed",
          dataField: "CommittedDate",
          gcType: "Date",
        },

        {
          gcLabel: "Created By",
          dataField: "CreatedBy",
          gcType: "String",
          width: 150,
        },
        {
          dataField: "FriendlyStatus",
          gcType: "String",
          gcSubType: "Chip",
          cellTemplate: "status-cell-template",
        },

        {
          gcLabel: "",
          gcType: "String",
          cssClass: "more-menu",
          gcSubType: "IconButton",
          cellTemplate: "menu-cell-template",
        },
      ]);
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "FriendlyStatus",
              gcLabel: "Status",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                items: [
                  { text: "In Progress", value: "In Progress" },
                  { text: "Completed", value: "Completed" },
                  { text: "Cancelled", value: "Cancelled" },
                ],
                valueExpr: "value",
                displayExpr: "text",
                searchEnabled: true,
              },
            },
            {
              dataField: "Type",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Type",
              editorOptions: {
                editorType: "dxSelectBox",
                items: [
                  {
                    text: "Item",
                    value: "Item",
                  },
                  {
                    text: "Supplier",
                    value: "Supplier",
                  },
                  {
                    text: "Category 1",
                    value: "Category 1",
                  },
                  {
                    text: "Category 2",
                    value: "Category 2",
                  },
                  {
                    text: "Category 3",
                    value: "Category 3",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },

            {
              dataField: "CountDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Count Date",
            },
            {
              dataField: "DateCreated",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date Created",
            },
            {
              dataField: "CommittedDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Commited Date",
            },
          ]),
        },
      ];
    },
    hasCommitCancelAccess() {
      return FeatureStorage.checkPermission("StocktakeManagement", "create");
    },
  },
  methods: {
    async onItemClick(e) {
      let payload = { Code: e.itemData.data.data.Code };
      let grid = this.$refs["stocktake-grid"].instance;

      this.$logger.trackEventButtonClick(
        `Stocktake List ${e.itemData.menuText}`,
        payload
      );

      if (e.itemData.menuText == "Commit") {
        await StockTakeListService.commitStockTake(payload);
        grid.refresh();
      } else if (e.itemData.menuText == "Cancel") {
        await StockTakeListService.cancelStockTake(payload);
        grid.refresh();
      }
    },
    onMasterCellClick(e) {
      if (e.columnIndex != 7) {
        if (e.data.FriendlyStatus === "Completed") {
          this.$router.push({
            path: `/stocktake/review/${e.data.Code}`,
          });
        } else if (e.data.FriendlyStatus === "In Progress") {
          this.$router.push({
            path: `/stocktake-count/edit/${e.data.Code}`,
          });
        } else if (e.data.FriendlyStatus !== "Cancelled") {
          this.$router.push({
            path: `/stock-take/count/${e.data.Code}`,
          });
        }
      }
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.$router.push({
                path: "/stocktake/create",
              });
            },
          },
        },
        searchPanel,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
